import {useInjex} from '@injex/react-plugin';
import ReportingPresetReportsManagerMdl from '../../managers/reportingPresetReportsManager.mdl';

export default function useReportingPresetReportsManager(): ReportingPresetReportsManagerMdl {
    const [inject] = useInjex();
    return inject<ReportingPresetReportsManagerMdl>('reportingPresetReportsManager');
}
